import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";
import projImg4 from "../assets/img/project-img4.png";
import projImg5 from "../assets/img/project-img5.png";
import projImg6 from "../assets/img/project-img6.png";
import collegeImg from '../assets/img/lincoln.png';
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
      title: "StudioPick",
      description: "Recording Studio Booking Service",
      lang: "(Full-stack HTML/CSS/JS)",
      imgUrl: projImg1,
    },
    {
      title: "Nathaniel Aguilar's Portfolio",
      description: "Client Portfolio",
      lang: "(WordPress)",
      imgUrl: projImg2,
    },
    {
      title: "LionHub Wireframe",
      description: "Campus App for Students",
      lang: "(Adobe XD)",
      imgUrl: projImg3,
    },
    {
      title: "Gunnison University",
      description: "Employee Career Path Finder",
      lang: "(PowerApps)",
      imgUrl: projImg4,
    },
    {
      title: "ECHO Dashboard",
      description: "Company Growth Manager",
      lang: "(PowerApps)",
      imgUrl: projImg5,
    },
    {
      title: "COMING SOON",
      description: "New projects in progress...",
      imgUrl: projImg6,
    },
  ];

  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2>About Me</h2>
                  <p>Throughout my educational career, I have worked on various projects in the computer science field, gaining valuable skills such as UI/UX design, web development, software development, agile ceremonies, and so much more.</p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                      <Nav.Item>
                        <Nav.Link eventKey="first">Education</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">Projects</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third">Resume</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                      <Tab.Pane eventKey="first">
                        <p>I am currently a student at Lincoln University studying Computer Science. I am deeply passionate about technology and its potential to change the world. I find computer science to be a fascinating and constantly evolving field, and I am eager to learn more about it and apply my knowledge to create innovative solutions that make a real difference in people's lives. I am excited to be attending Lincoln University because of its strong computer science program and the opportunities it provides to gain hands-on experience and collaborate with other like-minded students and faculty members.</p>
                        <img src={collegeImg} className="collegeImg" alt="React logo" />
                        
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">

                        <Row>
                          {
                            projects.map((project, index) => {
                              return (
                                <ProjectCard
                                  key={index}
                                  {...project}
                                />
                              )
                            })
                          }
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="third">
                        <p>Want to learn more about me? Here's my resume:</p>
                        <button className="resumeButton">
                          <a className="buttonText" href="DKnightResume.pdf" download="Dknightresume.pdf">
                            Download Resume
                          </a>
                        </button>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
